// removed by extract-text-webpack-plugin
module.exports = {"btn-link":"btn-link","studentName":"studentName"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentName/StudentName.scss
// module id = m8OE
// module chunks = 0